module.exports = __webpack_public_path__ + "static/media/E-Learning.352b4321.jpg";